export const SET_BAR_PROGRESS = 'SET_BAR_PROGRESS'
export const REQUEST_ERROR = 'REQUEST_ERROR'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const SUBMITTED = 'SUBMITTED'
export const CALCULATE_OVERALL = 'CALCULATE_OVERALL'
export const TEST_CALCULATE_OVERALL = 'TEST_CALCULATE_OVERALL'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js